var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartoLogoXs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo/Negative/Symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo/Negative/Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0434783,40 C31.0651609,40 40,31.045695 40,20 C40,8.954305 31.0651609,0 20.0434783,0 C9.02179565,0 0.0869565217,8.954305 0.0869565217,20 C0.0869565217,31.045695 9.02179565,40 20.0434783,40 Z",
    id: "Halo",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Circle",
    cx: 20.0434783,
    cy: 20,
    rx: 6.65217391,
    ry: 6.66666667
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartoLogoXs);
export default __webpack_public_path__ + "static/media/carto-logo-xs.5b24a36a84d8a2cd75520f6750b0ee44.svg";
export { ForwardRef as ReactComponent };